// src/slices/comboSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const fetchComboDetails = createAsyncThunk(
  'combo/fetchComboDetails',
  async (comboId) => {
    const res = await axios.get(`${window.BASE_API_URL}getComboDataById/${comboId}`);
    return res.data.data.data; // based on your JSON nesting
  }
);

const comboSlice = createSlice({
  name: 'combo',
  initialState: {
    combo: null,
    selections: {}, // { categoryIndex: { menuId: { modifiers: {...}, quantity } } }
    loading: false,
    error: null,
  },
  reducers: {
    toggleMenuInCategory(state, action) {
      const { categoryIndex, menuId, max } = action.payload;
      const cat = state.selections[categoryIndex] || {};
      const isSelected = !!cat[menuId];
      if (isSelected) {
        delete cat[menuId];
      } else if (Object.keys(cat).length < max) {
        cat[menuId] = { modifiers: {}, quantity: 1 };
      }
      state.selections[categoryIndex] = cat;
    },
    toggleModifier(state, action) {
      const { categoryIndex, menuId, groupId, optionId, maxSelect, singleSelect } = action.payload;
      const menuSel = state.selections[categoryIndex]?.[menuId];
      if (!menuSel) return;
      if (!menuSel.modifiers[groupId]) menuSel.modifiers[groupId] = {};
      const group = menuSel.modifiers[groupId];
      const isSelected = !!group[optionId];
      if (isSelected) {
        delete group[optionId];
      } else {
        if (singleSelect) menuSel.modifiers[groupId] = { [optionId]: 1 };
        else if (Object.keys(group).length < maxSelect) group[optionId] = 1;
      }
    },
    clearCombo(state) {
      state.combo = null;
      state.selections = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchComboDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchComboDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.combo = action.payload;
      })
      .addCase(fetchComboDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { toggleMenuInCategory, toggleModifier, clearCombo } = comboSlice.actions;
export default comboSlice.reducer;
